import React from "react"
import {sendToServer} from "../BidibDataProvider";

import {MdOutlineSettingsEthernet} from "react-icons/md";
import {FaUsb} from "react-icons/fa";

import {PiPlugs, PiPlugsConnected} from "react-icons/pi";
import { TiDeleteOutline } from "react-icons/ti";
import { GrCycle } from "react-icons/gr";

import IconButton from './IconButton.tsx'

import './bidib.css';
import {BIDIB_LINK_DESCRIPTOR_ROLE_INTERFACE} from "./BidibMessages";
import {connect} from "react-redux";

const Connection = ({data, record}) => {

    if( data === undefined ){
        data = record;
    }



    const ip = record?.ip;
    const port = record?.port;
    const device = record?.device;

    const connection_peer = (ip || device) ? record?.device?.length ? record?.device : `${record?.ip}:${record?.port}` : null


    const serial = data.contype === "serial"
    const icon = serial ? <FaUsb/> : <MdOutlineSettingsEthernet/>
    const connected = data.connected
    const paired = data.paired



    const autoconnect = record?.autoconnect

    const isDistributed = data.distributed !== undefined && data.distributed === true

    const isServer = data.networkrole === "server" || data.linkrole === 1

    const isInterface = data.linkrole === BIDIB_LINK_DESCRIPTOR_ROLE_INTERFACE

    const is_url = data.user && data.user.includes('http')

    const uid = data.uid

    function getLinkState(ls) {
        const k = parseInt(ls)
        switch (k) {
            case 0:
                return "NONE"
            case 1:
                return "UNPAIRED"
            case 2:
                return "THEIR_ACCEPT"
            case 3:
                return "MY_ACCEPT"
            case 4:
                return "PAIRED"
            default:
                return "_UNKNOWN_"
        }
    }

    function actionOnOther(){
        return parseInt(data.pairing_state) > 0 && data.link_state === parseInt(3)
    }

    function autoConnectClick() {
        let cx = {
            cmd: "autoconnect",
            uid: data.uid,
            autoconnect: !autoconnect
        }

        sendToServer(cx)
    }

    function connectClick() {
        const msg = data.connected ? "disconnect" : "connect"

        let cx = {
            cmd: msg,
            uid: data.uid
        }

        console.log(cx)
        sendToServer(cx)
    }

    function deleteClick() {
        const msg = "delete"

        let cx = {
            cmd: msg,
            uid: data.uid
        }
        sendToServer(cx)
    }

    function pairClick() {
        const msg = data.paired ? "unpair" : "pair"
        console.log(msg + " " + data.uid)

        let cx = {
            cmd: msg,
            uid: data.uid
        }

        sendToServer(cx)
    }

    const con = connected?'on':'neutral'

    const buttonstyle = {
        background: connected?'#448844':'#b9deff',
    }

    return (


        <div style={{
            padding: '10px',
            margin: '10px',
            border: '1px solid black',
            borderRadius: '5px',
            background: actionOnOther() ? 'rgb(234,214,82)' : data.connected ? 'rgb(151,175,109)' : 'rgb(166,166,166)',
            color: 'rgb(27,35,54)',
        }}
            >

            <div style={{
                    display: "flex",
                }}>


                <>
                    <div style={{
                        float: "left",
                        width: "90%",
                    }}>


                        <div>
                            <div>
                            <div style={{
                                fontWeight: 'bold',
                                marginRight: '5px',

                            }}>{icon}&nbsp;{data.user}{isDistributed?" D":""}</div>
                            <div style={{
                                fontWeight: 'normal',
                                marginRight: '5px',
                                paddingTop: '3px',

                            }}>
                                {is_url ? <a href={data.user} target='_blank'>{data.user}</a> : data.product}</div>
                            </div>
                            <div style={{fontStyle: 'italic', marginRight: '5px', paddingTop: '3px'}}>{uid}</div>

                        </div>

                        {connection_peer &&
                        <div style={{
                            paddingTop: "6px",
                        }}>
                            {connection_peer}
                        </div>}

                    </div>

                    <div style={{
                        float: "right",
                        width: "10%",
                    }}>

                        {<IconButton iconOn={<PiPlugsConnected />} iconOff={<PiPlugs />} on={connected} callback={connectClick} title={connected?'disconnect':'connect'}/>}

                        {!isServer?<IconButton iconOn={<GrCycle />} iconOff={<GrCycle />} on={autoconnect} callback={autoConnectClick} title={'autoconnect'}/>:null}

                        {connected ? null : <div className={`iconButton ${con}`}
                                                 onClick={deleteClick}>
                            <TiDeleteOutline/>
                        </div>}

                    </div>

                </>

            </div>

            {actionOnOther() ? <div style={{
                background: 'rgb(255,136,0)',
                marginTop: '10px',
                padding: '4px',
                borderRadius: '5px',
                border: '#0C5404 1px solid',
                textAlign: 'center',
            }}
            >
                Press PAIR on device!
            </div> : null}

        </div>

    )
}

function mapStateToProps(state, other) {
    //if( other?.type === "record" ) {
        const rx = state.bidib.data.record.find(it => it.uid === other.uid);
        if (rx !== undefined) {
            //   console.log(`A ${other.uid}`)
            //   console.log(rx)

        }
    //}

    //if( other?.type === "node" ) {
        const ry = state.bidib.data.node.find(it => it.uid === other.uid);

        return {data: ry, record: rx}
    //}
}

export default connect(mapStateToProps)(Connection)